<button type="button" class="nt__bell" aria-haspopup="dialog" [class.is-open]="open" [attr.aria-expanded]="open" [attr.aria-label]="'shell.notes.badge' | transloco: { n: unseen }" (click)="toggle()">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.bell"></path></svg>
  <span *ngIf="unseen > 0" class="nt__count">{{ unseen }}</span>
</button>

<div *ngIf="open" class="nt__panel" role="dialog" [attr.aria-label]="'shell.notes.title' | transloco">
  <span class="nt__caret" aria-hidden="true"></span>
  <div class="nt__head">
    <span class="nt__head-icon" aria-hidden="true">
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.bell"></path></svg>
    </span>
    <span class="nt__titles">
      <b>{{ 'shell.notes.title' | transloco }}</b>
      <span *ngIf="events.length">{{ 'shell.notes.summary' | transloco: { fresh: unread, total: events.length } }}</span>
    </span>
    <button *ngIf="unread > 0" type="button" class="nt__all" (click)="markAllAsRead()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.checks"></path></svg>
      {{ 'shell.notes.readAll' | transloco }}
    </button>
  </div>

  <div *ngIf="events.length" class="nt__list">
    <ng-container *ngFor="let g of groups">
      <span class="nt__day">{{ g.key ? (g.key | transloco) : (g.date | date: 'd MMMM') }}</span>
      <div *ngFor="let n of g.items" class="nt__item" [class.is-unread]="!n.readDate">
        <span class="nt__bar" aria-hidden="true"></span>
        <button type="button" class="nt__open" (click)="read(n)">
          <span class="nt__tile" aria-hidden="true">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.megaphone"></path></svg>
          </span>
          <span class="nt__body">
            <span class="nt__line"><span class="nt__topic">{{ n.topic }}</span><span class="nt__time">{{ n.createDate | date: 'HH:mm' }}</span></span>
            <span class="nt__text">{{ n.text }}</span>
          </span>
        </button>
        <button *ngIf="!n.readDate" type="button" class="nt__mark" [title]="'shell.notes.markRead' | transloco" [attr.aria-label]="'shell.notes.markRead' | transloco" (click)="markOne($event, n)">
          <i class="nt__mark-dot"></i>
          <svg class="nt__mark-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.check"></path></svg>
        </button>
      </div>
    </ng-container>
  </div>

  <div *ngIf="!events.length" class="nt__empty">
    <span class="nt__empty-icon" aria-hidden="true">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.bell"></path></svg>
      <span class="nt__empty-ok"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.check"></path></svg></span>
    </span>
    <b>{{ 'shell.notes.emptyTitle' | transloco }}</b>
    <span>{{ 'shell.notes.emptyText' | transloco }}</span>
  </div>

  <div class="nt__foot">
    <a class="nt__more" target="_blank" rel="noopener" [href]="profileUrl">
      {{ 'shell.notes.showAll' | transloco }}
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.right"></path></svg>
    </a>
  </div>
</div>

<div *ngIf="selected" class="nt__modal">
  <div class="nt__scrim" (click)="closeSelected()"></div>
  <div class="nt__dialog" role="dialog" aria-modal="true" aria-labelledby="cc-nt-topic">
    <span class="nt__dialog-head">
      <span class="nt__dialog-icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.megaphone"></path></svg>
      </span>
      <span class="nt__titles">
        <b id="cc-nt-topic">{{ selected.topic }}</b>
        <span>{{ selected.createDate | date: 'dd.MM · HH:mm' }}</span>
      </span>
    </span>
    <p class="nt__dialog-text">{{ selected.text }}</p>
    <button type="button" class="nt__ok" (click)="closeSelected()">{{ 'shell.notes.ok' | transloco }}</button>
  </div>
</div>
